export const MAX_PER_PAGE = 10;

export const ASSEMBLY_MODE = 'assembly';
export const GALLERY_MODE = 'gallery';

// TODO enable when needed
// export const HYBRID_MODE = 'hybrid';

export const AVAILABLE_MODE = [
  {
    label: 'Assembly',
    value: ASSEMBLY_MODE,
  },
  {
    label: 'Gallery',
    value: GALLERY_MODE,
  },
  // {
  //   label: 'Hybrid',
  //   value: HYBRID_MODE,
  // },
];
